import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

interface DeviceInfo {
    isMobile: boolean;
    isPc: boolean;
    isReady: boolean;
}

/**
 * 检测当前设备类型
 * 优先使用 User-Agent，fallback 到屏幕宽度
 */
export function useDevice(): DeviceInfo {
    const [device, setDevice] = useState<DeviceInfo>(() => {
        // SSR 兼容：服务端默认返回 PC
        if (typeof window === 'undefined') {
            return { isMobile: false, isPc: true, isReady: false };
        }
        const isMobile = checkIsMobile();
        return { isMobile, isPc: !isMobile, isReady: true };
    });

    useEffect(() => {
        const handleResize = () => {
            const isMobile = checkIsMobile();
            setDevice({ isMobile, isPc: !isMobile, isReady: true });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return device;
}

/**
 * 检测是否为移动端
 */
function checkIsMobile(): boolean {
    // 1. 优先检测 User-Agent
    const ua = navigator.userAgent.toLowerCase();
    const mobileKeywords = [
        'android', 'iphone', 'ipad', 'ipod', 'mobile',
        'webos', 'blackberry', 'opera mini', 'windows phone'
    ];
    const isMobileUA = mobileKeywords.some(keyword => ua.includes(keyword));
    
    if (isMobileUA) return true;
    
    // 2. fallback：检测屏幕宽度
    return window.innerWidth < MOBILE_BREAKPOINT;
}

/**
 * 获取设备类型（非 hook 版本，用于初始化）
 */
export function getDeviceType(): 'mobile' | 'pc' {
    if (typeof window === 'undefined') return 'pc';
    return checkIsMobile() ? 'mobile' : 'pc';
}